import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { SessionWorldlinePaymentCallback } from '@/components/payment/SessionWorldlinePaymentCallback';
import { MobilePageWrapper } from '@/components/ui+/MobilePageWrapper';

const searchSchema = z.object({
  paymentId: z.coerce.string().optional(),
});

export const Route = createFileRoute('/s/$sessionUuid/payment-callback')({
  component: Component,
  validateSearch: searchSchema,
});

function Component() {
  const { sessionUuid } = Route.useParams();
  const { paymentId } = Route.useSearch();
  const navigate = useNavigate();

  return (
    <MobilePageWrapper>
      <SessionWorldlinePaymentCallback
        sessionUuid={sessionUuid}
        paymentIdFromUrl={paymentId}
        onSuccess={() => navigate({ to: '/s/$sessionUuid', params: { sessionUuid } })}
        onBack={() => navigate({ to: '/s/$sessionUuid', params: { sessionUuid } })}
      />
    </MobilePageWrapper>
  );
}
